export const TEST_MODULE = {
  // vuex typings
  ACTIONS: 'ACTIONS',
}
